import { ReactNode } from 'react';

import { Card } from '@/components/layout/Card/Card';

interface IntegrationCardContainerProps {
  children: ReactNode;
}

export function IntegrationCardContainer({
  children,
}: IntegrationCardContainerProps) {
  return (
    <Card variant="outlined" sx={{ p: 2, minHeight: 320 }}>
      {children}
    </Card>
  );
}
